"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // styleguide/ThemeWrapper.js

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

var theme_1 = __importDefault(require("./utils/theme"));

var GlobalStyle = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    *{\n        box-sizing: border-box;\n        padding: 0;\n        margin: 0;\n        max-width: 100%;\n    }\n    html, body{\n        height: 100%;\n    }\n"], ["\n    *{\n        box-sizing: border-box;\n        padding: 0;\n        margin: 0;\n        max-width: 100%;\n    }\n    html, body{\n        height: 100%;\n    }\n"])));

var ThemeWrapper = function ThemeWrapper(props) {
  var children = props.children;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: theme_1.default
  }, react_1.default.createElement(react_1.default.Fragment, null, children, react_1.default.createElement(GlobalStyle, null)));
};

exports.default = ThemeWrapper;
ThemeWrapper.displayName = 'ThemeWrapper';
var templateObject_1;